module.exports = __webpack_public_path__ + "static/media/gcash-failed.1393fe55.png";